import { RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoint, userOptions } from '../endpoints';
import { Person, UserWireData } from 'app/components/access-panel/shared/types';

export const api = {
  getUser: (id: number) => {
    return new RemoteAdminData(endpoint.user)
      .resource<ApiResponse<UserWireData>>()
      .withId(id)
      .single();
  },
  getRole: (id: number) => {
    return new RemoteAdminData(endpoint.role.data)
      .resource<ApiResponse<Person>>()
      .withId(id)
      .single();
  },
  addUser: async (user) => {
    const response = await new RemoteAdminData(endpoint.user)
      .resource<any>()
      .create(user, false);
    return await response.json();
  },
  updateUser: async (id: number, user: any) => {
    return new RemoteAdminData(endpoint.user)
      .resource<ApiResponse<any>>()
      .withId(id)
      .save(user);
  },
  changePassword: async (id: number, password: string) => {
    return new RemoteAdminData(endpoint.changePassword(id))
      .resource<ApiResponse<any>>()
      .save({ password });
  },
  changePersonId: async (id: number, personId: string) => {
    return new RemoteAdminData(endpoint.changePersonId(id))
      .resource<ApiResponse<any>>()
      .save({ personId });
  },
  getRoleOptions: async () => {
    const response = await new RemoteAdminData(userOptions.role)
      .resource<ApiResponse<Value[]>>()
      .single();
    return response.data;
  },
  saveDatabaseAccount: (id: number, password: string) => {
    return new RemoteAdminData(endpoint.addDatabaseAccount(id))
      .resource<any>()
      .create({ password }, false);
  },
  resetDatabaseAccount: (id: number, password: any) => {
    return new RemoteAdminData(endpoint.resetDatabaseAccount(id))
      .resource<ApiResponse<any>>()
      .save({ password });
  },
  deleteDatabaseAccount: (id: number) => {
    return new RemoteAdminData(endpoint.deleteDatabaseAccount(id))
      .resource<ApiResponse<any>>()
      .httpDelete(id);
  }
};
